import { CDS, APPLE_PROVIDER, isAppleProvider } from "../../../common/utils/subscriptionProvider";

export interface ReferralSubscription {
    subscriptionEmail?: string;
    subscriptionId?: string | number;
    type?: string;
    provider?: string;
    postalCode?: number | string;
    product?: string;
    region?: string;
}

/* eslint-disable quote-props */
const PROVIDER_PARAM_MAP = {
    "0": CDS,
    "1": CDS, // formerly QSS
    "2": APPLE_PROVIDER
};
/* eslint-enable quote-props */

export function getReferralParams(params: {provider?: "0" | "1" | "2"; [s: string]: undefined | string} = {}): Partial<Subscription> {
    let provider: undefined | string;

    if (params.provider) {
        provider = PROVIDER_PARAM_MAP[params.provider];
    }

    const subscription: ReferralSubscription = {
        subscriptionEmail: params.email,
        subscriptionId: params.subscriptionId,
        type: "PRINT", // front-end no longer needs to differentiate
        provider: provider as string,
        postalCode: params.postalCode || "",
        product: params.product as string
    };

    const isValidReferral = validateSubscription(subscription);

    return isValidReferral ? subscription : {};
}

export function validateSubscription(subscription: ReferralSubscription): boolean {
    if (isAppleProvider(subscription.provider)) {
        return Boolean(subscription.subscriptionEmail);
    }

    return Boolean(
        subscription.subscriptionEmail
        && subscription.subscriptionId
        && subscription.provider);
}

export default {
    getReferralParams,
    validateSubscription
};
